import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { InternalGrid } from '@paygreen/paygreen-ui';
import { IsMobile } from '../../../utils/tools';
import { AdministratorManagementCard } from '../adminUserDetails/administratorManagementCard';
import AccountManagementCard from '../adminUserDetails/AccountManagementCard';
import AddressManagementCard from './addressManagementCard/AddressManagementCard';
import CharityManagementCard from './charityManagementCard/CharityManagementCard';

const AdminCharityDetailsCards = ({
    accountData,
    setAccountData,
    setIsLoading,
    isLoading,
    refresh,
}) => (
    <InternalGrid
        displayType="grid"
        gridTemplateColumns={IsMobile() ? '1fr' : 'auto auto'}
        gridGap="lg"
        hasStaticWidth={IsMobile()}
        alignItems="flex-start"
        justifyItems="stretch"
    >
        <CharityManagementCard
            accountData={accountData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setAccountData={setAccountData}
            refresh={refresh}
        />

        <AddressManagementCard
            accountData={accountData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setAccountData={setAccountData}
            refresh={refresh}
        />

        <AdministratorManagementCard
            accountData={accountData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setAccountData={setAccountData}
            isShop={false}
            refresh={refresh}
        />

        <AccountManagementCard
            accountData={accountData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            setAccountData={setAccountData}
            refresh={refresh}
        />
    </InternalGrid>
);

AdminCharityDetailsCards.propTypes = {
    accountData: PropTypes.object,
    setAccountData: PropTypes.func,
    isLoading: PropTypes.bool,
    setIsLoading: PropTypes.func,
    refresh: PropTypes.func,
};

AdminCharityDetailsCards.defaultProps = {
    isLoading: true,
};

export default withTranslation('common')(AdminCharityDetailsCards);
